(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('basketBar', function($q, tripService, $filter, $routeParams, basketStore, broker, customCurrencyFilter, bookingService, arrayUtil, currencyService) {
    return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=BasketBar',
            scope: {
                hideButton: '=',
                buttonHandler: '&',
                buttonDisabler: '&',
                isDeposit: '=?'
            },
            link(scope) {
                if ($routeParams.pb) {
                    return;
                }
                scope.isMobileDevice = TRPCONFIG.IsMobileDevice;
                scope.costBreakdowns = [];
                scope.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
                scope.roundedPrice = function(amount, symbol) {
                    let final = $filter('roundedCurrency')(amount, symbol);
                    return final.replace(symbol, '');
                };

                broker.subscribe('basketBarDirective', 'feesUpdated', _setPaymentTotalPlusFees);

                function _setPaymentTotalPlusFees(fees) {
                    const cardFee = (fees && fees.data && fees.data.CardHandlingFee) || 0;
                    //creating clean data object
                    scope.fees = fees && fees.data ? { data: angular.copy(fees.data) } : null;
                    scope.totalDepositWithCardFee = (scope.deposit || 0) + cardFee;
                }

                function isScrolledIntoView(el) {
                    let rect = el.getBoundingClientRect();
                    let elemTop = rect.top;
                    let elemBottom = rect.bottom;
                    let isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
                    return isVisible;
                }

                scope.openHolidayInfo = function() {
                    let infoModal = document.getElementById('holidayInfoModal');
                    let editSearchModal = document.getElementById('editSearchModal');
                    let priceElement = document.getElementById('price-section');
                    let editElement = document.getElementById('edit-section');
                    priceElement.classList.toggle('active');

                    document.addEventListener('scroll', function() {
                        let topOfPage = document.getElementById('top-of-page');
                        let isAtTop = isScrolledIntoView(topOfPage);
                        if (isAtTop) {
                            priceElement.classList.remove('active');
                            editElement.classList.remove('active');
                            infoModal.style.display = 'none';
                            editSearchModal.style.display = 'none';
                        }
                    }, true);

                    if (editElement.classList.contains('active')) {
                        editElement.classList.remove('active');
                    }
                    if (infoModal.style.display === 'block') {
                        infoModal.style.display = 'none';
                    } else {
                        editSearchModal.style.display = 'none';
                        infoModal.style.display = 'block';
                    }
                };

                scope.editSearch = function() {
                    let infoModal = document.getElementById('holidayInfoModal');
                    let editSearchModal = document.getElementById('editSearchModal');
                    let priceElement = document.getElementById('price-section');
                    let editElement = document.getElementById('edit-section');
                    let searchPanel = document.querySelectorAll('.ekh-search-panel')[0];
                    let searchPanel2 = document.querySelectorAll('.ekh-search-panel')[1];
                    if (searchPanel2 && searchPanel2 !== undefined) {
                        searchPanel2.classList.add('ekh-top-margin');
                    } else if (!searchPanel2 && searchPanel2 === undefined) {
                        searchPanel.classList.add('ekh-top-margin');
                    }

                    document.addEventListener('scroll', function() {
                        let topOfPage = document.getElementById('top-of-page');
                        let isAtTop = isScrolledIntoView(topOfPage);
                        if (isAtTop) {
                            priceElement.classList.remove('active');
                            editElement.classList.remove('active');
                            infoModal.style.display = 'none';
                            editSearchModal.style.display = 'none';
                        }
                    }, true);

                    if (searchPanel && searchPanel.classList.contains('panel-hide')) {
                        searchPanel.classList.remove('panel-hide');
                    }
                    editElement.classList.toggle('active');
                    if (priceElement.classList.contains('active')) {
                        priceElement.classList.remove('active');
                    }
                    if (editSearchModal.style.display === 'block') {
                        editSearchModal.style.display = 'none';
                    } else {
                        infoModal.style.display = 'none';
                        editSearchModal.style.display = 'block';
                    }
                };

                tripService.getTrip($routeParams.tripId).then(function(trip) {
                    function getCostbreakdowns() {
                        const reqs = [basketStore.totalDeposit(trip.BasketId, $routeParams.productId),
                                basketStore.costBreakdownGrouped(trip.BasketId),
                                basketStore.getTaxAdjustmentValue(trip.BasketId),
                                basketStore.payDirectTotal(trip.BasketId),
                                basketStore._costByProduct(1, trip.BasketId),
                                basketStore._costByProduct(6, trip.BasketId)];
                        if (trip.BookingId) {
                            reqs.push(bookingService.getBooking(trip.BookingId));
                        }

                        $q.all(reqs).then(function([totalDeposit, costBreakdownGrouped, taxAdjustments, payDirectTotal, flightCost, marhabaCost, booking]) {

                            const costType = {
                                Unknown: 0,
                                Accommodation: 1,
                                Discount: 20,
                                AccommodationCancellationProtection: 21,
                                AccommodationLocalFeesAndTaxes: 22,
                                AccommodationExtraTransfer: 23,
                                AccommodationExtraEvent: 24,
                                AccommodationExtraAttraction: 25,
                                AccommodationExtra: 26,
                            };

                            if (!costBreakdownGrouped.isPackage && (trip.TripType === tripService.tripTypes.Hotel)) {

                                const { costBreakdown = [] } = costBreakdownGrouped[0] || {};

                                const extraCostItems = costBreakdown.filter(cost => {
                                    const match = _.get(cost, 'ParentId') && _.get(cost, 'TypeId') ===
                                    (costType.AccommodationExtraTransfer || costType.AccommodationExtraEvent
                                        || costType.AccommodationExtraAttraction || costType.AccommodationExtra || costType.AccommodationExtra || costType.AccommodationLocalFeesAndTaxes || costType.AccommodationCancellationProtection || costType.Discount);
                                        return match;

                                    }).filter(extra => extra);

                                const roomCostItems = costBreakdown.filter(cost => !_.get(cost, 'ParentId')
                                && _.get(cost, 'TypeId') === costType.Accommodation).map((room, LinkId) => {
                                    return { ...room, LinkId };
                                });

                                if (extraCostItems && extraCostItems.length > 0 && roomCostItems && roomCostItems.length > 0) {

                                    const updatedRoomCostItems = roomCostItems.map(room => {
                                        return { RoomId: room.Id, RoomDescription: room.Description };
                                    });

                                    const enhancedExtras = extraCostItems.map(extras => {
                                        return { ...extras, ...updatedRoomCostItems.find(acc => acc.RoomId === extras.ParentId) };
                                    });

                                    const updatedExtrasCostItems = enhancedExtras.map((extra, LinkId) => {
                                        const splitDescription = _.get(extra, 'RoomDescription').split('(');

                                        const Description = splitDescription[1] ? `${extra.Description} (${splitDescription[1]}` : extra.Description;
                                        return {
                                            ...extra,
                                            Description,
                                            LinkId,
                                        };
                                    });

                                    const updatedCostBreakdown = [...roomCostItems, ...updatedExtrasCostItems];
                                    const costsSortedById = updatedCostBreakdown.sort((a, b) => (a.LinkId >= b.LinkId) ? 1 : -1);

                                    costBreakdownGrouped[0].costBreakdown = costsSortedById;
                                }
                            }
                            scope.costBreakdowns = costBreakdownGrouped;
                            if (window.location.pathname.includes('book') || window.location.pathname.includes('options')) {
                                priceUpdate();
                            } else {
                                setTimeout(priceUpdate(), 500);
                            }
                            function currencySymbol(total) {
                                let price = scope.roundedPrice(total, '');
                                let currencyCode = TRPCONFIG.Domain.CurrencyCode;
                                let newPrice;

                                if (currencyCode.match(/GIP|EUR/g)) {
                                    newPrice = scope.roundedPrice(total, '');
                                } else if (currencyCode.match(/USD/g)) {
                                    price = price.replace(/£/g, '');
                                    newPrice = `$${price}`;
                                } else {
                                    price = price.replace(/[^0-9,.]/g, '');
                                    newPrice = `${TRPCONFIG.Domain.CurrencyCode}${price}`;
                                }

                                return newPrice;
                            }

                            function getPriceFromString(str) {
                                str = str.replace(/[^0-9]/g, '');
                                let num = Number(str);
                                return num;
                            }

                            function checkSummaryPrice() {
                                let target = document.querySelector('.sticky-panel-hidden');
                                let observer = new MutationObserver(mutations => {
                                    mutations.forEach(mutation => {
                                        if (target || mutation === 'characterData') {
                                            let summaryTotal = document.querySelector('.teaser-price .price-value');
                                            let bannerTotal = document.querySelector('.sticky-panel-hidden .price.total');
                                            if (summaryTotal) {
                                                let bannerText = bannerTotal.innerText;
                                                let summaryText = summaryTotal.innerText;

                                                let bannerNum = getPriceFromString(bannerText);
                                                let summaryNum = getPriceFromString(summaryText);

                                                if (bannerNum !== summaryNum && summaryNum !== 0) {
                                                    summaryTotal.innerHTML = bannerText;
                                                }
                                            }
                                        }
                                    });
                                });
                                let config = {
                                    subtree: true,
                                    attributes: false,
                                    childList: false,
                                    characterData: true
                                };
                                observer.observe(target, config);
                            }
                            function priceUpdate() {
                                scope.hotelCost = 0;
                                let hotelData = JSON.parse(sessionStorage.getItem('hotelData'));
                                let hotelSelected = {};
                                const searchHotelData = JSON.parse(sessionStorage.getItem('hotelSearchResults'));
                                if (hotelData && searchHotelData) {
                                    hotelSelected = searchHotelData.filter(function(hData) {
                                        return hData.Id === hotelData.Id;
                                    });
                                }
                                if (window.location.pathname.includes('book') || window.location.pathname.includes('options') ||
                                window.location.pathname.includes('flights')) {
                                    scope.total = costBreakdownGrouped.total;
                                    if (costBreakdownGrouped[0] && costBreakdownGrouped[0].group === 1) {
                                        scope.hotelCost = costBreakdownGrouped[0].total;
                                    }
                                    let deposit = totalDeposit;
                                    let bannerTotal = document.querySelector('.sticky-panel-hidden .price.total');
                                    if (bannerTotal) {
                                        bannerTotal.innerHTML = currencySymbol(scope.total);
                                    }

                                    if (booking && window.location.pathname.includes('book')) {
                                        deposit += booking.UserData.PaymentDetails.DepositAmount;
                                        let roundedTotal = currencySymbol(costBreakdownGrouped.total - payDirectTotal);
                                        let roundedDeposit = currencySymbol(deposit);

                                        document.addEventListener('click', e => {
                                            let attributes = Array.from(e.target.attributes);
                                            if (attributes[0] && attributes[0].value && attributes[0].value === 'radio') {
                                                let parents = e.target.parentNode.parentNode;
                                                let classes = parents.classList.value;
                                                if (classes.includes('total')) {
                                                    document.querySelector('.sticky-panel-hidden .price.deposit').innerHTML = roundedTotal;
                                                    document.querySelector('.mobile-view .deposit').innerHTML = roundedTotal;
                                                } else if (classes.includes('deposit')) {
                                                    document.querySelector('.sticky-panel-hidden .price.deposit').innerHTML = roundedDeposit;
                                                    document.querySelector('.mobile-view .deposit').innerHTML = roundedDeposit;
                                                }
                                            }
                                        });
                                    }
                                    scope.deposit = deposit;
                                } else {
                                    scope.total = flightCost + marhabaCost;
                                    let payableAmount = 0;
                                    if (hotelData && hotelData.MinCost) {
                                        scope.total = flightCost + marhabaCost + hotelData.MinCost;
                                        scope.hotelCost = hotelData.MinCost;
                                    }
                                    if (hotelSelected && hotelSelected.length > 0 && hotelSelected[0].IsCityTaxIncludedInPrice) {
                                        const numberOfRooms = hotelData && hotelData.RequestedRooms ? hotelData.RequestedRooms.length : 1;
                                        payableAmount = scope.total - (numberOfRooms * hotelSelected[0].CityTax);
                                    } else {
                                        payableAmount = scope.total;
                                    }
                                    scope.deposit = (hotelSelected[0] && hotelSelected[0].HolidayDeposit) ? hotelSelected[0].HolidayDeposit : payableAmount;
                                }
                                scope.taxAdjustment = taxAdjustments;
                                scope.isPackage = costBreakdownGrouped.isPackage;

                                checkSummaryPrice();
                            }
                            if (scope.binRangeDiscount != null) {
                                scope.total -= scope.binRangeDiscount.DiscountValue;
                                if (!scope.isDeposit) {
                                    scope.deposit -= scope.binRangeDiscount.DiscountValue;
                                }
                            }
                            tripService.getCurrency($routeParams.tripId).then(currency => {
                                scope.currency = currency;
                                scope.symbol = currencyService.getSymbol(currency);

                                scope.totalDeposit = customCurrencyFilter(scope.deposit, currency);
                                _setPaymentTotalPlusFees(scope.fees);
                            });
                        });

                        // persist any open content panel
                        const i = arrayUtil.indexOf(scope.costBreakdowns, function(cb) {
                            return cb.open;
                        });
                        if (i >= 0) {
                            scope.costBreakdowns[i].open = true;
                        }
                    }

                    getCostbreakdowns();

                    broker.subscribe('basketBarDirective', 'basketUpdated', _.debounce(getCostbreakdowns, 100));
                    broker.subscribe('basketBarDirective', 'paymentDataUpdated', _.debounce(getCostbreakdowns, 100));

                    broker.subscribe('basketBarDirective', 'discountUpdated', _setBinRangeDiscount);
                    broker.subscribe('basketBarDirective', 'boardPriceSelectionsUpdate', _setBoardTypePriceUpdates);

                    function _setBinRangeDiscount(discount) {
                        if (discount.data != null) {
                            scope.binRangeDiscount = discount.data[0];
                        } else {
                            scope.binRangeDiscount = null;
                        }
                        getCostbreakdowns();
                    }

                    function _setBoardTypePriceUpdates(price) {
                        scope.total = price.data;
                        let hotelData = JSON.parse(sessionStorage.getItem('hotelData'));
                        let hotelSelected = {};
                        const searchHotelData = JSON.parse(sessionStorage.getItem('hotelSearchResults'));
                        if (hotelData && searchHotelData) {
                            hotelSelected = searchHotelData.filter(function(hData) {
                                return hData.Id === hotelData.Id;
                            });
                        }
                        if (hotelSelected && hotelSelected.length > 0 && !hotelSelected[0].HolidayDeposit) {
                            if (hotelSelected[0].IsCityTaxIncludedInPrice) {
                                const numberOfRooms = hotelData && hotelData.RequestedRooms ? hotelData.RequestedRooms.length : 1;
                                scope.deposit = price.data - (numberOfRooms * hotelSelected[0].CityTax);
                            } else {
                                scope.deposit = price.data;
                            }
                        }
                    }

                    scope.$on('$destroy', () => {
                        broker.unsubscribe('basketBarDirective');
                    });
                });

                scope.sectionClass = function(index) {
                    return scope.costBreakdowns[index].open ? 'expanded' : '';
                };

                scope.toggleSection = function(index) {
                    scope.costBreakdowns.forEach(function(cb, i) {
                        if (i !== index) {
                            cb.open = false;
                        }
                    });

                    scope.costBreakdowns[index].open = !scope.costBreakdowns[index].open;
                };
            }
        };
    }
);
})();
